import * as React from 'react';
import "./ShippingForm.css";
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import NavbarB from "../NavbarB";
import Footer from "../footer/Footer";
import {Box, Button, Link, TextField, Typography} from "@mui/material";
import { useLocation } from 'react-router-dom';
import headerIMG from "../images/header-wine.jpg";
import ShippingCart from "./ShippingCart";
import {useEffect, useState} from "react";
import {ShopHeader} from "./ShopHeader";

const ShippingForm = () => {
  const location = useLocation();
  const products = location.state?.products;
  const [shippingCosts, setShippingCosts] = useState([]);
  const [paymentData, setPaymentData] = useState("");
  let orderNumber = "";
  const [csrftoken, setCsrftoken] = useState(null);

  // Estado para los valores del formulario
  const [formValues, setFormValues] = useState({
    name: '',
    address: '',
    postalCode: '',
    emailAddress: '',
    phoneNumber: '',
    privacyPolicy: false
  });

  // Estado para los errores del formulario
  const [formErrors, setFormErrors] = useState({
    nameError: false,
    addressError: false,
    postalCodeError: false,
    emailAddressError: false,
    phoneNumberError: false,
    privacyPolicyError: false,
  });

  const [formEmpty, setFormEmpty] = useState({
    nameEmpty: true,
    addressEmpty: true,
    postalCodeEmpty: true,
    emailAddressEmpty: true,
    phoneNumberEmpty: true,
    privacyPolicyEmpty: true,
  });

  useEffect(() => {
    const getCSRFToken = async () => {
      try {
        const response = await fetch('https://api.bodegasanimamviventem.es/api/get-csrf-token/', {
          method: 'GET',
          credentials: 'include',
        });
        if (!response.ok) {
          throw new Error('No se pudo obtener el token CSRF');
        } else {
            const cookies = document.cookie.split(';');
            const csrfCookie = cookies.find(cookie => cookie.trim().startsWith('csrftoken='));
            if (csrfCookie) {
              setCsrftoken(csrfCookie.split('=')[1]);  // Extraer y guardar el token CSRF de la cookie
            }
        }
      } catch (error) {
        console.error('Error al obtener el token CSRF:', error);
      }
    };

    getCSRFToken();
  }, []);  // Solo se ejecuta al montar el componente

  useEffect(() => {
    // Obtener productos del backend
    const fetchShippingNone = async () => {
      try {
        const response = await fetch('https://api.bodegasanimamviventem.es/api/shipping/', {
          method: 'GET',
        });
        if (!response.ok) {
          throw new Error('Error al obtener los costes de envio');
        }
        const data = await response.json();
        setShippingCosts(data);
        console.log(shippingCosts);
      } catch (error) {
        console.error('Error al obtener los productos:', error);
      }
    };

    fetchShippingNone();
  }, []);

  const initiatePayment = async () => {
    orderNumber = ""
    await setPaymentData("");
    console.log("Pago iniciado: ", orderNumber);
    try {
      const response = await fetch('https://api.bodegasanimamviventem.es/api/payment/', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRFToken': csrftoken,
        },
        body: JSON.stringify({
          urlBase: window.location.href,
          products: products
        })
      });
      if (!response.ok) {
        console.error('Error al iniciar el pago:', response.status);
        return;
      }
      const responseJson = await response.json()
      console.log("ORder created: ", responseJson.orderNumber);
      orderNumber = responseJson.orderNumber;
      return true;
    } catch (error) {
      console.error('Error al iniciar el pago:', error);
      return false;
    }
  }

  const fetchShipping = async (value) => {
    try {
      const response = await fetch('https://api.bodegasanimamviventem.es/api/shipping/' + value, {
        method: 'GET',
      });
      if (!response.ok) {
        throw new Error('Error al obtener los costes de envio');
      }
      const data = await response.json();
      setShippingCosts(data);
    } catch (error) {
      console.error('Error al obtener los productos:', error);
    }
  };

  // Función para validar los campos
  const validateField = (name, value) => {
    switch (name) {
      case 'postalCode':
        const postalCodeRegex = /^[0-9]{5}$/;
        return !(postalCodeRegex.test(value) && value >= 1000 && value <= 52999);
      case 'emailAddress':
        console.log("Field: ", name, " ", value)
        var validRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
        if(value.match(validRegex)) {
            return false;
        } else {
            return true;
        }
      case 'name':
      case 'address':
        console.log("Field: ", name)
        console.log("Error: ", value.trim() === '')
        return value.trim() === '';
      case 'privacyPolicy':
        return !value;
      case 'phoneNumber':
        const phoneRegex = /^\+?\d{9,15}$/;
        return !phoneRegex.test(value);

      default:
        return false;
    }
  };

  // Manejador de cambio de entrada para todos los campos
  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;

    const newValue = type === 'checkbox' ? checked : value;

    setFormValues({
      ...formValues,
      [name]: newValue,
    });

    const error = validateField(name, newValue)

    setFormErrors({
      ...formErrors,
      [`${name}Error`]: error,
    });

    setFormEmpty({
      ...formEmpty,
      [`${name}Empty`]: false,
    });

    if (name === 'postalCode' && !error) {
        fetchShipping(value);
    }
  };

  const sendPaymentData = async () => {
    console.log("Order number: ", orderNumber)
      const response = await fetch('https://api.bodegasanimamviventem.es/api/payment/' + orderNumber, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
              userData: {
                name: formValues.name,
                address: formValues.address,
                postalCode: formValues.postalCode,
                emailAddress: formValues.emailAddress,
                phoneNumber: formValues.phoneNumber
              },
              urlBase: window.location.origin + "/Shop"
            }
        ),
      });

      if (!response.ok) {
        return false;
      }
      setPaymentData(await response.text())
      return true;
  };

  const preparePayment = async () => {
      let errors = (formErrors.nameError || formErrors.addressError || formErrors.postalCodeError || formErrors.emailAddressError || formErrors.phoneNumberError || formErrors.privacyPolicyError)
      let empty = (formEmpty.nameEmpty || formEmpty.addressEmpty || formEmpty.postalCodeEmpty || formEmpty.emailAddressEmpty || formEmpty.phoneNumberEmpty || formEmpty.privacyPolicyEmpty)
      if (!errors && !empty) {
          console.log("paymentData")
          console.log("payment")
          let postSuccess1 = await initiatePayment();
          let postSuccess2 = await sendPaymentData();
      }
  }

  useEffect(() => {
    if (paymentData) {
      const formElement = document.querySelector("form");
      if (formElement) {
        const handleFormSubmit = async (e) => {
            e.preventDefault();
            let errors = (formErrors.nameError || formErrors.addressError || formErrors.postalCodeError || formErrors.emailAddressError || formErrors.phoneNumberError || formErrors.privacyPolicyError)
            let empty = (formEmpty.nameEmpty || formEmpty.addressEmpty || formEmpty.postalCodeEmpty || formEmpty.emailAddressEmpty || formEmpty.phoneNumberEmpty || formEmpty.privacyPolicyEmpty)
            if (!errors && !empty) {
              formElement.submit();
            }
        };
        formElement.addEventListener('submit', handleFormSubmit);
        return () => {
          formElement.removeEventListener('submit', handleFormSubmit);
        };
      }
    }
  }, [paymentData, formErrors, formEmpty]);

  return (
    <div className={"backgroundForm"}>
      <Box sx={{ bgcolor: '#eee', minHeight: '100vh', position: {xs: 'relative', lg: 'static'}, top: {xs: '90px'} }}>
      <ShopHeader/>
      <div className={"formClass"}>
        {products && (
          <div className={"cartTableContainer"}>
            {shippingCosts.text && (
              <ShippingCart products={products} shippingCosts={shippingCosts} />
            )}
          </div>
        )}
        <TextField
          required
          margin="dense"
          className={"textField"}
          id="name"
          name="name"
          color="success"
          label="Nombre"
          variant="outlined"
          value={formValues.name}
          onChange={handleInputChange}
          error={formErrors.nameError}
          helperText={formErrors.nameError ? 'El nombre no debe estar vacío.' : ''}
        />
        <TextField
          required
          margin="dense"
          className={"textField"}
          id="emailAddress"
          name="emailAddress"
          color="success"
          label="Dirección de correo"
          variant="outlined"
          value={formValues.emailAddress}
          onChange={handleInputChange}
          error={formErrors.emailAddressError}
          helperText={formErrors.emailAddressError ? 'Email invalido.' : ''}
        />
        <TextField
          required
          margin="dense"
          className={"textField"}
          id="phoneNumber"
          name="phoneNumber"
          color="success"
          label="Número de teléfono"
          variant="outlined"
          value={formValues.phoneNumber}
          onChange={handleInputChange}
          error={formErrors.phoneNumberError}
          helperText={formErrors.phoneNumberError ? 'Número de teléfono invalido.' : ''}
        />
        <TextField
          required
          margin="dense"
          className={"textField"}
          id="address"
          name="address"
          color="success"
          label="Dirección"
          variant="outlined"
          value={formValues.address}
          onChange={handleInputChange}
          error={formErrors.addressError}
          helperText={formErrors.addressError ? 'La dirección no debe estar vacía.' : ''}
        />
        <TextField
          required
          margin="dense"
          className={"textField"}
          id="postalCode"
          name="postalCode"
          color="success"
          label="Código Postal"
          variant="outlined"
          value={formValues.postalCode}
          onChange={handleInputChange}
          error={formErrors.postalCodeError}
          helperText={formErrors.postalCodeError ? 'Código postal inválido.' : ''}
        />
        <FormControlLabel required control={<Checkbox />} onChange={handleInputChange} name="privacyPolicy" label={
            <>
              He leído y acepto la{' '}
              <Link href="/privacy-policy" target="_blank" rel="noopener">politica de privacidad</Link>
            </>
          }
        />
        {paymentData ? (
          <div id="redsysButton" dangerouslySetInnerHTML={{ __html: paymentData }} />
        ) : (
          <Button className="base-button" onClick={preparePayment}>Enviar</Button>
        )}
      </div>
      <NavbarB />
      <Footer />
      </Box>
    </div>
  );
};

export default ShippingForm;
